// import React, { useCallback } from 'react';
// import { Box, Button, Typography, Paper } from '@mui/material';
// import Particles from 'react-tsparticles';
// import { loadFull } from 'tsparticles';

// const LandingPage = ({ onLoginClick, onRegisterClick }) => {
//   const particlesInit = useCallback(async (engine) => {
//     await loadFull(engine);
//   }, []);

//   return (
//     <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
//       <Particles
//         id="tsparticles"
//         init={particlesInit}
//         options={{
//           fullScreen: { enable: true, zIndex: 0 },
//           background: { color: { value: "#0a192f" } },
//           fpsLimit: 60,
//           particles: {
//             number: { value: 70, density: { enable: true, area: 800 } },
//             color: { value: "#50E3C2" },
//             shape: { type: "circle" },
//             opacity: {
//               value: 0.5,
//               random: { enable: true, minimumValue: 0.1 }
//             },
//             size: {
//               value: 3,
//               random: { enable: true, minimumValue: 1 }
//             },
//             move: {
//               enable: true,
//               speed: 2.5,
//               direction: "none",
//               random: false,
//               straight: false,
//               outModes: "out"
//             },
//             links: {
//               enable: true,
//               distance: 140,
//               color: "#50E3C2",
//               opacity: 0.35,
//               width: 1
//             }
//           },
//           detectRetina: true,
//         }}
//       />

//       <Paper
//         elevation={12}
//         sx={{
//           position: 'absolute',
//           top: '25%',
//           left: 0,
//           right: 0,
//           margin: 'auto',
//           maxWidth: 460,
//           p: 5,
//           bgcolor: 'rgba(30, 50, 70, 0.85)',
//           color: 'white',
//           borderRadius: 4,
//           boxShadow: '0 15px 60px rgba(0,0,0,0.6)',
//           backdropFilter: 'blur(12px)',
//           textAlign: 'center',
//           zIndex: 1,
//         }}
//       >
//         <Typography variant="h2" sx={{ fontWeight: 'bold', mb: 3, color: '#50E3C2' }}>
//           YapZone
//         </Typography>
//         <Typography variant="body1" sx={{ mb: 5, color: '#A0C8F0', fontSize: 19 }}>
//           The modern realtime chat application to connect and communicate seamlessly.
//         </Typography>
//         <Button
//           variant="contained"
//           color="secondary"
//           fullWidth
//           onClick={onLoginClick}
//           sx={{ mb: 3, py: 1.3, fontWeight: 'bold' }}
//         >
//           Login
//         </Button>
//         <Button
//           variant="outlined"
//           color="secondary"
//           fullWidth
//           onClick={onRegisterClick}
//           sx={{ fontWeight: 'bold', py: 1.3, borderColor: '#50E3C2', color: '#50E3C2' }}
//         >
//           Register
//         </Button>
//       </Paper>
//     </Box>
//   );
// };

// export default LandingPage;


import React, { useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

const LandingPage = ({ onLoginClick, onRegisterClick }) => {
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  return (
    <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden', bgcolor: '#090C0F' }}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: { enable: false },
          background: { color: { value: "#090C0F" } },
          fpsLimit: 60,
          particles: {
            number: { value: 55, density: { enable: true, area: 900 } },
            color: { value: ["#00C2B3", "#00E5D3", "#007A70"] },
            shape: { type: "circle" },
            opacity: { value: 0.45, random: { enable: true, minimumValue: 0.1 } },
            size: { value: 2, random: { enable: true, minimumValue: 0.5 } },
            move: { enable: true, speed: 1.2, direction: "none", outModes: "out" },
            links: { enable: true, distance: 160, color: "#00C2B3", opacity: 0.18, width: 1 }
          },
          detectRetina: true,
        }}
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', zIndex: 0 }}
      />

      <Box sx={{
        position: 'relative', zIndex: 1, height: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        px: 3,
      }}>
        <Box sx={{
          display: 'flex', flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center', gap: { xs: 5, md: 12 },
          maxWidth: 900, width: '100%',
        }}>
          {/* Left branding */}
          <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>
            <Box sx={{
              display: 'inline-flex', alignItems: 'center', gap: 1.5,
              mb: 3,
            }}>
              <Box sx={{
                width: 42, height: 42, borderRadius: '10px',
                bgcolor: '#00C2B3', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <svg width="20" height="20" viewBox="0 0 22 22" fill="none">
                  <path d="M3 6C3 4.9 3.9 4 5 4H17C18.1 4 19 4.9 19 6V13C19 14.1 18.1 15 17 15H12L8 19V15H5C3.9 15 3 14.1 3 13V6Z" fill="#090C0F"/>
                </svg>
              </Box>
              <Typography sx={{
                fontFamily: "'Outfit', sans-serif", fontWeight: 700,
                fontSize: 20, color: '#F0F4F8', letterSpacing: '-0.02em',
              }}>YapZone</Typography>
            </Box>

            <Typography sx={{
              fontFamily: "'Outfit', sans-serif", fontWeight: 700,
              fontSize: { xs: 40, md: 54 }, lineHeight: 1.08,
              color: '#F0F4F8', letterSpacing: '-0.03em', mb: 2.5,
            }}>
              Chat without<br />
              <Box component="span" sx={{ color: '#00C2B3' }}>limits.</Box>
            </Typography>

            <Typography sx={{
              fontFamily: "'Outfit', sans-serif", fontWeight: 400,
              fontSize: 17, color: '#4A5A68', lineHeight: 1.7,
              maxWidth: 360,
            }}>
              Real-time messaging, group chats, private conversations — all in one secure place.
            </Typography>
          </Box>

          {/* Right auth card */}
          <Box sx={{
            width: { xs: '100%', sm: 340 }, flexShrink: 0,
            bgcolor: '#0E1318',
            border: '1px solid #1A2228',
            borderRadius: '16px',
            p: { xs: 3, sm: 4 },
          }}>
            <Typography sx={{
              fontFamily: "'Outfit', sans-serif", fontWeight: 600,
              fontSize: 22, color: '#F0F4F8', mb: 0.5,
            }}>
              Get started
            </Typography>
            <Typography sx={{
              fontFamily: "'Outfit', sans-serif", fontSize: 13.5, color: '#3A4A58', mb: 3.5,
            }}>
              Join thousands already on YapZone
            </Typography>

            <Button
              fullWidth
              onClick={onLoginClick}
              sx={{
                mb: 1.5, py: 1.4,
                bgcolor: '#00C2B3', color: '#090C0F',
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 600, fontSize: 15,
                borderRadius: '10px', textTransform: 'none',
                '&:hover': { bgcolor: '#00D5C5' },
              }}
            >
              Sign in to YapZone
            </Button>

            <Button
              fullWidth
              onClick={onRegisterClick}
              sx={{
                py: 1.4,
                bgcolor: 'transparent', color: '#A0B0BF',
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 500, fontSize: 15,
                borderRadius: '10px', textTransform: 'none',
                border: '1px solid #1A2228',
                '&:hover': { bgcolor: '#141B22', borderColor: '#253035', color: '#F0F4F8' },
              }}
            >
              Create account
            </Button>

            <Box sx={{ display: 'flex', gap: 1, mt: 3.5, flexWrap: 'wrap' }}>
              {['Encrypted', 'Group chats', 'File sharing'].map(f => (
                <Box key={f} sx={{
                  px: 1.5, py: 0.5,
                  bgcolor: '#0A1015', border: '1px solid #1A2228',
                  borderRadius: '6px',
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 11, color: '#00C2B3',
                }}>
                  {f}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LandingPage;